<template>
    <b-list-group>
        <b-list-group-item v-for="kr in krs" :key="kr.id">
            <b-media vertical-align="center">
                <avatar
                    :src="kr.user_picture"
                    :username="kr.user_name"
                    slot="aside"
                    :size="40"
                />
                <b-media
                    style="margin-left: 10px"
                    right-align
                    vertical-align="center"
                >
                    <div>{{ kr.title }}</div>
                    <small>
                        <span v-if="kr.last_checkin">
                            Check-in:
                            <timeago
                                :datetime="new Date(kr.last_checkin.date)"
                            />
                        </span>
                        <span v-else>{{ $t('insights.noCheckInSoFar') }}</span>
                    </small>
                    <slot
                        slot="aside"
                        :objectiveId="kr.objective_id"
                        :keyResultId="kr.id"
                    />
                </b-media>
            </b-media>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
import Avatar from 'vue-avatar'

export default {
    name: 'ListKeyResults',
    props: ['krs'],
    components: {
        Avatar,
    },
}
</script>
